export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
    }
}

export function numberWithCommas(n, decimalCount = 2) {
    if (n == 0) {
        return "0.00"
    }
    if (!isNaN(n) && (n != "") && (n !== null)) {
        return formatMoney(n, decimalCount, ".", ",");
    }

    return n;
}

export function integerWithCommas(n) {
    if (!isNaN(n) && (n != "") && (n !== null)) {
        return formatMoney(n, 0, "", ",");
    }

    return "";
}

export function getHeatColor(current, min, max) {
    if (min === max) {
        return "#00a63e"; // avoid division by zero
    }

    // Clamp ratio between 0 and 1
    const ratio = Math.min(Math.max((current - min) / (max - min), 0), 1);

    // Start (green) and end (red)
    const start = { r: 0x00, g: 0xa6, b: 0x3e }; // #00a63e
    const end   = { r: 0xff, g: 0x64, b: 0x67 }; // #ff6467

    const r = Math.round(start.r + (end.r - start.r) * ratio);
    const g = Math.round(start.g + (end.g - start.g) * ratio);
    const b = Math.round(start.b + (end.b - start.b) * ratio);

    return `rgb(${r}, ${g}, ${b})`;
}